export default "__VITE_ASSET__CivCBjtd__"